import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CertificateConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CertificateService } from './api/certificate.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CertificateApiModule {
    public static forRoot(configurationFactory: () => CertificateConfiguration): ModuleWithProviders<CertificateApiModule> {
        return {
            ngModule: CertificateApiModule,
            providers: [ { provide: CertificateConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CertificateApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CertificateApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
